export const SPLIT = 'split';
